import LoadingContainer from 'components/Loading/LoadingContainer'
import LoadingPresentation from 'components/Loading/LoadingPresentation'

export default {
  Container: LoadingContainer,
  Presentation: LoadingPresentation,
}
